<template>
  <div class="table-container">
    <errors-list :errors="errorList" />
    <TableCommon
      title="字典数据"
      :checkbox-config="{ highlight: true }"
      :radio-config="{ highlight: true }"
      :custome-config="() => vxeShowCustom('xTable')"
    >
      <template #button>
        <table-button v-if="mode === 'add'" name="add" tip="新建" @click="addRow" />
        <table-button v-if="mode === 'add'" name="add" tip="删除" @click="removeRow" />
      </template>
      <vxe-grid
        ref="xTableEdit"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        height="300"
        max-height="500"
        align="center"
        size="mini"
        :checkbox-config="{ highlight: true }"
        :radio-config="{ highlight: true }"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptions.columns"
        :data="gridOptions.data"
      >
        <template #CUSTOMER="{row,$rowIndex}">
          <!-- <el-input v-model="row.CUSTOMER" placeholder="请输入客户编码" size="mini" /> -->
          <wly-input
            v-model="row.CUSTOMER"
            input-type="customer"
            @enter="handleEnter(...arguments, $rowIndex)"
            @handleSuffixClick="openSelectDialog($event, $rowIndex)"
          />
        </template>
        <template #CUST_NAME="{row}">
          <el-input v-model="row.CUST_NAME" disabled size="mini" />
        </template>
      </vxe-grid>
    </TableCommon>
    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <client-select ref="dialogEdit" />
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
          >取消</el-button
        >
        <el-button type="primary" size="small" icon="el-icon-circle-check" @click="submitHandle"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
export default {
  components: {
    ClientSelect
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    editRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      curIdx: 0,
      dialogTitle: '客户选择',
      showDialog: false,
      errorList: [],
      rowSeq: 0,
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'CUSTOMER', title: '客户编码', slots: { default: 'CUSTOMER' } },
          { field: 'CUST_NAME', title: '客户名称', slots: { default: 'CUST_NAME' } }
        ]
      }
    }
  },
  created() {
    if (this.editRows.length) {
      this.gridOptions.data.push(
        ...this.editRows.map(item => {
          return { ...item }
        })
      )
    }
  },
  methods: {
    // 打开窗口
    openSelectDialog(e, idx) {
      e.target.blur()
      this.curIdx = idx
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(async res => {
        this.gridOptions.data[this.curIdx].CUST_NAME = res.customerName
        this.gridOptions.data[this.curIdx].CUSTOMER = res.customerCode
        this.showDialog = false
      })
    },
    // 控件回车
    async handleEnter(e, type, data, idx, mode) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.gridOptions.data[idx].CUST_NAME = data.customerName
      this.gridOptions.data[idx].CUSTOMER = data.customerCode
    },
    addRow() {
      this.gridOptions.data.push({
        CUSTOMER: '',
        CUST_NAME: ''
      })
    },
    removeRow() {
      const checkedList = this.$refs['xTableEdit'].getCheckboxRecords()
      if (!checkedList.length) return

      checkedList.forEach(file => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    validRows() {
      try {
        if (!this.gridOptions.data.length) {
          throw new Error('请添加要保存的数据！')
        }
        this.gridOptions.data.forEach(item => {
          if (!item.CUSTOMER) {
            throw new Error('请输入完整的信息！')
          }
        })
      } catch (e) {
        this.$message.error(e.message)
        return false
      }

      return this.gridOptions.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/client-manage/components/customerDictEdit.vue